const $$splitComponentImporter = () => import('/app/src/routes/dashboard/admin/therapists/$therapistId.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/dashboard/admin/therapists/$therapistId")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type AdminTherapist = Therapist & {
  questionnaireResponse?: EnrollmentQuestionnaireResponse | null;
};